module.exports = __webpack_public_path__ + "img/image_28.ba7fe7a0.png";